import { render, staticRenderFns } from "./goods-evaluate.vue?vue&type=template&id=35f9f760&scoped=true"
import script from "./goods-evaluate.vue?vue&type=script&lang=js"
export * from "./goods-evaluate.vue?vue&type=script&lang=js"
import style0 from "./goods-evaluate.vue?vue&type=style&index=0&id=35f9f760&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9f760",
  null
  
)

export default component.exports